module.exports = __webpack_public_path__ + "img/PRCFLogo - Dark.38aab527.png";